'use client';
import posthog from '@Soultrics/_utils/posthog';
import Cookies from 'universal-cookie';

import { CookieName } from '../setCookie';

import EventType from './types';

function capture(event: EventType, payload?: Record<string, any>) {
  const isLoggedIn = !!new Cookies().get(CookieName.USER_TOKEN);

  const details = {
    env: process.env.NEXT_PUBLIC_EVENT_ENV,
    isLoggedIn,
    payload: payload,
    version: '0.0.1',
  };

  if (process.env.NEXT_PUBLIC_EVENT_ENV !== 'cypress') {
    posthog?.capture(event, details);
  }

  if (process.env.NEXT_PUBLIC_EVENT_ENV === 'cypress') {
    void fetch('/coverage', {
      body: JSON.stringify({
        event: { details, eventType: event },
      }),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
  }
}

export default capture;
